import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import { Navigation, FreeMode } from 'swiper/modules';
import { bindSwiperNavigationA11y } from '../common/syncSwiperNavigationA11y';

export default class CategoriesList {
    constructor() {
        this.sections = document.querySelectorAll('.block-categories-list');
        this.instances = [];
        this.handleResize = this.debounce(this.rebuild.bind(this), 300);
        this.bindExplorerForms();
        this.ready();
        window.addEventListener('resize', this.handleResize);
    }

    bindExplorerForms() {
        document.querySelectorAll('[data-content-explorer]').forEach(form => {
            const categorySelect = form.querySelector('select[name="categoria"]');

            form.addEventListener('submit', () => {
                const categoryUrl = categorySelect?.selectedOptions[0]?.dataset.categoryUrl;

                if (categoryUrl) {
                    form.action = categoryUrl;
                }

                form.querySelectorAll('input, select').forEach(field => {
                    if (!String(field.value || '').trim()) {
                        field.disabled = true;
                    }
                });
            });
        });
    }

    debounce(fn, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    rebuild() {
        this.instances.forEach(obj => {
            obj.main?.destroy(true, true);
        });
        this.instances = [];
        this.ready();
    }

    ready() {
        if (this.sections.length === 0) return;

        this.sections.forEach(section => {
            const slider = section.querySelector('.swiper');
            if (!slider) return;

            const navigationNext = section.querySelector('.slider-button-next');
            const navigationPrev = section.querySelector('.slider-button-prev');

            const swiperInstance = new Swiper(slider, {
                modules: [Navigation, FreeMode],
                spaceBetween: 8,
                freeMode: true,
                grabCursor: true,
                watchSlidesProgress: true,
                slidesPerView: 'auto',
                navigation: navigationNext && navigationPrev ? {
                    nextEl: navigationNext,
                    prevEl: navigationPrev,
                } : false,
                breakpoints: {
                    0: {
                        slidesOffsetBefore: 28,
                        slidesOffsetAfter: 28,
                    },
                    1024: {
                        slidesOffsetAfter: 28,
                    }
                }
            });

            bindSwiperNavigationA11y(swiperInstance);

            this.instances.push({ main: swiperInstance });
        });
    }
}

if (document.querySelector('.block-categories-list')) {
    new CategoriesList();
}
